import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import defaultLogo from 'assets/img/pebsteel.png';
import { PUBLIC_LOGO_URL } from 'helpers/useAppSetting';

const Logo = ({
  at = 'auth',
  width = 58,
  className,
  textClass,
  ...rest
}) => {
  const appSettingsData = useSelector((state) => state.app_settings?.data || []);

  const logoSetting = appSettingsData.find((s) => s.key === 'APP_LOGO');
  const appNameSetting = appSettingsData.find((s) => s.key === 'APP_NAME');

  // Before sign-in the settings are not in redux: read APP_LOGO from the public
  // endpoint, and use the bundled logo only if that fails (none uploaded / API down).
  const [publicFailed, setPublicFailed] = useState(false);
  const logoSrc  = logoSetting?.logo_url || (publicFailed ? defaultLogo : PUBLIC_LOGO_URL);
  const appName  = appNameSetting?.value || 'Portal';

  return (
    <Link
      to="/"
      className={classNames(
        'tw-no-underline',
        { 'navbar-brand tw-text-left': at === 'navbar-vertical' },
        { 'navbar-brand tw-text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'tw-flex',
          {
            'tw-items-center tw-py-3': at === 'navbar-vertical',
            'tw-items-center': at === 'navbar-top',
            'tw-items-center tw-justify-center tw-font-bold tw-text-lg tw-mb-4':
              at === 'auth'
          },
          className
        )}
      >
        <img className="tw-mr-2" src={logoSrc} alt={appName} width={width}
          onError={() => { if (!logoSetting?.logo_url) setPublicFailed(true); }} />
        <span className={classNames('font-sans-serif', textClass)}>{appName}</span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

export default Logo;
